export const SCOPE = 'AutoInsights';

const types = {
  SET_DURATION: `${SCOPE}/SET_DURATION`,
}

export default types;
